import { defineMessages } from 'react-intl';

export const messages: {
	statusOnTrack: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusAtRisk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusOffTrack: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	phasePaused: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	phasePending: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	phaseInProgress: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	phaseDone: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	phaseCancelled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusForDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusOnDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusOnTrack: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-on-track.non-final',
		defaultMessage: 'On track',
		description:
			"Status label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project is progressing as expected. Shown as a status badge or label in the card header. The purpose is to clearly communicate the project's current status, which indicates the project is meeting its goals and timeline.",
	},
	statusAtRisk: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-at-risk.non-final',
		defaultMessage: 'At risk',
		description:
			"Status label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project may encounter issues but is not yet off track. Shown as a status badge or label in the card header. The purpose is to clearly communicate the project's current status, which indicates the project has potential risks that need attention.",
	},
	statusOffTrack: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-off-track.non-final',
		defaultMessage: 'Off track',
		description:
			"Status label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project is not meeting its goals or timeline. Shown as a status badge or label in the card header. The purpose is to clearly communicate the project's current status, which indicates the project needs immediate attention to get back on track.",
	},
	phasePaused: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-paused.non-final',
		defaultMessage: 'Paused',
		description:
			'Phase label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project phase is currently paused. Shown as a phase badge or label in the card header. The purpose is to clearly communicate the project phase status, which indicates work on this phase has been temporarily halted.',
	},
	phasePending: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-pending.non-final',
		defaultMessage: 'Pending',
		description:
			'Phase label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project phase is waiting to begin. Shown as a phase badge or label in the card header. The purpose is to clearly communicate the project phase status, which indicates the phase has not yet started.',
	},
	phaseInProgress: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-in-progress.non-final',
		defaultMessage: 'In progress',
		description:
			'Phase label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project phase is currently active and work is being done. Shown as a phase badge or label in the card header. The purpose is to clearly communicate the project phase status, which indicates the phase is actively being worked on.',
	},
	phaseDone: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-done.non-final',
		defaultMessage: 'Completed 🎉',
		description:
			'Phase label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project phase has been completed. Shown as a phase badge or label in the card header. The emoji (🎉) is part of the message and represents celebration. The purpose is to clearly communicate the project phase status, which indicates the phase has been successfully finished.',
	},
	phaseCancelled: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.phase-cancelled.non-final',
		defaultMessage: 'Cancelled',
		description:
			'Phase label text displayed in the Atlassian project status update action card header within the AI conversation interface, indicating that the project phase has been cancelled and will not be completed. Shown as a phase badge or label in the card header. The purpose is to clearly communicate the project phase status, which indicates the phase has been terminated and will not proceed.',
	},
	statusForDate: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-for-date.non-final',
		defaultMessage: '{status} for {date}',
		description:
			'Status label text displayed in the Atlassian project status update action card header within the AI conversation interface, showing a project status that applies to a specific date. Shown as text in the card header. The status placeholder will be substituted with a status label (e.g., "On track", "At risk"). The date placeholder will be substituted with a formatted date (e.g., "March 1", "2024-03-01"). The purpose is to indicate that the status is planned or scheduled for a particular date (e.g., "On track for March 1").',
	},
	statusOnDate: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-header.status-on-date.non-final',
		defaultMessage: '{status} on {date}',
		description:
			'Status label text displayed in the Atlassian project status update action card header within the AI conversation interface, showing a project status that occurred on a specific date. Shown as text in the card header. The status placeholder will be substituted with a status label (e.g., "Completed", "Off track"). The date placeholder will be substituted with a formatted date (e.g., "March 1", "2024-03-01"). The purpose is to indicate that the status change happened on a particular date (e.g., "Completed on March 1").',
	},
});
